import { ArrowDown, CircleDashed } from "lucide-react";

import { Button } from "@/components/ui/button";


export const SwapSuggestionSheet = ({ open, onOpenChange, currentRecipe, carbTarget, suggestions, onSelectSuggestion, busy }) => {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[130] flex items-end bg-stone-950/35 px-4 pb-4 pt-12" data-testid="swap-suggestion-sheet-overlay">
      <div className="w-full rounded-[28px] border border-stone-200 bg-white p-4 shadow-2xl" data-testid="swap-suggestion-sheet">
        <div className="mx-auto h-1.5 w-14 rounded-full bg-stone-200" />
        <p className="mt-4 text-xs font-semibold uppercase tracking-[0.24em] text-stone-500" data-testid="swap-suggestion-sheet-kicker">
          Carb-aware swap
        </p>
        <h3 className="mt-2 text-lg font-semibold text-stone-900" data-testid="swap-suggestion-sheet-title">
          Top 3 carb-bewuste alternatieven voor deze maaltijd.
        </h3>
        <p className="mt-2 text-sm text-stone-600" data-testid="swap-suggestion-current-summary">
          Nu: {currentRecipe?.title} · {currentRecipe?.kcal_per_serving} kcal · {currentRecipe?.carbs_per_serving} g carbs
        </p>
        <p className="mt-1 text-sm text-stone-500" data-testid="swap-suggestion-target-summary">
          Richtdoel voor dit meal moment: {carbTarget} g carbs
        </p>

        <div className="mt-4 space-y-3">
          {suggestions?.map((suggestion) => (
            <button key={suggestion.recipe_id} type="button" className="w-full rounded-[22px] border border-stone-200 bg-stone-50 px-4 py-4 text-left transition-colors hover:bg-stone-100" onClick={() => onSelectSuggestion(suggestion.recipe_id)} disabled={busy} data-testid={`swap-suggestion-option-${suggestion.recipe_id}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-semibold text-stone-900">{suggestion.title}</p>
                  <p className="mt-2 text-xs text-stone-500">{suggestion.kcal_per_serving} kcal · {suggestion.carbs_per_serving} g carbs</p>
                </div>
                <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-medium text-emerald-800" data-testid={`swap-suggestion-delta-${suggestion.recipe_id}`}>
                  {suggestion.carb_delta <= 0 ? <ArrowDown className="mr-1 inline h-3 w-3" /> : null}
                  {suggestion.carb_delta > 0 ? "+" : ""}{suggestion.carb_delta} g
                </span>
              </div>
              <p className="mt-3 text-sm text-stone-600" data-testid={`swap-suggestion-tip-${suggestion.recipe_id}`}>
                {suggestion.substitution_tip}
              </p>
              {suggestion.reason_chips?.length ? (
                <div className="mt-3 flex flex-wrap gap-2" data-testid={`swap-suggestion-reason-chips-${suggestion.recipe_id}`}>
                  {suggestion.reason_chips.map((chip, chipIndex) => (
                    <span key={`${suggestion.recipe_id}-${chip}`} className="rounded-full bg-white px-2.5 py-1 text-[11px] font-medium text-stone-700" data-testid={`swap-suggestion-reason-chip-${suggestion.recipe_id}-${chipIndex}`}>
                      {chip}
                    </span>
                  ))}
                </div>
              ) : null}
            </button>
          ))}
        </div>

        {!suggestions?.length ? (
          <div className="mt-4 rounded-[22px] border border-dashed border-stone-300 bg-stone-50 px-4 py-4 text-sm text-stone-600" data-testid="swap-suggestion-empty-state">
            <CircleDashed className="mr-2 inline h-4 w-4" />
            Geen betere carb-swap gevonden voor dit moment.
          </div>
        ) : null}

        <Button variant="outline" className="mt-4 w-full rounded-full border-stone-200 bg-white" onClick={() => onOpenChange(false)} data-testid="swap-suggestion-close-button">
          Sluiten
        </Button>
      </div>
    </div>
  );
};